var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnDesignMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 50,
    viewBox: "0 0 57 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2504 48.25L56 24.875L42.2504 1.5H14.7503L1 24.875L14.7503 48.25H42.2504Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 31.75C32.2969 31.75 35.375 28.6719 35.375 24.875C35.375 21.0781 32.2969 18 28.5 18C24.7031 18 21.625 21.0781 21.625 24.875C21.625 28.6719 24.7031 31.75 28.5 31.75Z",
    stroke: "#2884FF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDesignMeasure);
export default __webpack_public_path__ + "static/media/icn-design-measure.2bd559c2a50a5a6340d01bb8e9eeddf3.svg";
export { ForwardRef as ReactComponent };